<template>
    <div>
        <o-field label="Application Number *" :type="fieldType('application_number')" :message="getError('application_number')">
            <o-input placeholder="Application Number" v-model="form.application_number"/>
        </o-field>

        <o-field label="Service Type *" :type="fieldType('service_type')" :message="getError('service_type')">
            <o-input placeholder="Service Type" v-model="form.service_type"/>
        </o-field>

        <o-field label="Status *" :type="fieldType('status')" :message="getError('status')">
            <o-select placeholder="Select a status" v-model="form.status" expanded>
                <option :value="null">Not Specified</option>
                <option
                    v-for="status in miscServicesStatuses"
                    :value="status.id"
                    :key="status.id">
                    {{ status.name }}
                </option>
            </o-select>
        </o-field>

        <o-field label="Applicant *" :type="fieldType('applicant_id')" :message="getError('applicant_id')">
            <o-select placeholder="Select an applicant" v-model="form.applicant_id" expanded>
                <option :value="null">Not Specified</option>
                <option
                    v-for="applicant in applicants"
                    :value="applicant.id"
                    :key="applicant.id">
                    {{ applicant.full_name }}
                </option>
            </o-select>
        </o-field>

        <o-field label="Expiration Date *" :type="fieldType('expiration_date')" :message="getError('expiration_date')">
          <Datepicker
              v-model="form.expiration_date"
              class="input"
              :config="{ enableTime: true }"
              placeholder="Pick a Date"/>
        </o-field>
    </div>
</template>

<script>
    import Application from '../../../mixins/Application'
    import HandlesForm from '../../../mixins/HandlesForm'
    import Datepicker from './../../../components/Datepicker'
    import { mapGetters } from 'vuex'

    export default {
        mixins: [Application, HandlesForm],

        components: {
            Datepicker
        },

        data () {
            return {
                form: {
                    application_number: null,
                    expiration_date: null,
                    service_number: null,
                    applicant_id: null,
                    service_type: null,
                    status: null
                }
            }
        },

        computed: {
            ...mapGetters({
                miscServicesStatuses: 'miscServicesStatuses',
                applicants: 'contacts'
            })
        }
    }
</script>
